import type { Product, ProductAnalytic } from '@prisma/client'
import type { SerializeFrom } from '@remix-run/server-runtime'

import type { ProductFull } from '~/models/product.server'

export const isProductPublished = (product: SerializeFrom<Product>) => {
  return product.publishedAt !== null && product.archivedAt === null
}

export interface ProductCardProps {
  product: SerializeFrom<ProductFull>
  analytics?: SerializeFrom<ProductAnalytic>
}

export const getProductCoverMedia = (
  product: Pick<ProductCardProps['product'], 'variants' | 'attachments'>
) => {
  // Find the default visible variant first
  const defaultVariant = product.variants.find(
    ({ archivedAt, isVisible, markers }) =>
      archivedAt == null && isVisible && markers.find((m) => m.trait.isDefault)
  )

  // If no default visible variant, find any visible variant
  const visibleVariant =
    defaultVariant ||
    product.variants.find(
      ({ archivedAt, isVisible }) => archivedAt == null && isVisible
    )

  const variantAttachments = product.attachments
    .filter(
      ({ archivedAt, targetId }) =>
        archivedAt == null && targetId == visibleVariant?.id
    )
    .sort((a, b) => Number(a.disposition) - Number(b.disposition))

  return variantAttachments?.[0]?.media
}
